<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('news.edit', { id: vm.$route.params.newsId })
  }),
  computed: {
    ...mapState('news', ['routeKey', 'routes', 'form', 'item']),
    crumbs: vm => [
      { text: vm.$t('news.title'), to: { name: 'news.index' } },
      { text: vm.$t('news.edit', { id: vm.$route.params.newsId }) }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('news/fetchItem', { route: to })
      await store.dispatch('news/fetchCategories')
      await store.dispatch('news/fetchSiteVersions')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('news', ['createItem', 'updateItem'])
  }
}
</script>
